// extracted by mini-css-extract-plugin
export default {"LegalPara":"ChangePassword_LegalPara__FST07"};